export class ExtendedMasterSecret {
  static type = 23;
}
